export const DISCOUNT_VIEWED = 'discount_viewed'
export const DISCOUNT_COOKIE_KEY = 'discount_slug'
export const PROMO_EXPLAINER_MODAL_SHOULD_BE_SHOWN =
  'promo_explainer_modal_should_be_shown'
export const BOGO_EXPLAINER_MODAL_SHOULD_BE_SHOWN =
  'bogo_explainer_modal_should_be_shown'
export const DISCOUNT_MODAL_SHOULD_BE_SHOWN = 'discount_modal_should_be_shown'
